export const COOKIE_NAME = 'cookie_consent'
export const COOKIE_EXPIRATION_TIME = 365 * 24 * 60 * 60 * 1000 // 1 year
